import { render, staticRenderFns } from "./ProjectsFilters.vue?vue&type=template&id=5342fa91"
import script from "./ProjectsFilters.vue?vue&type=script&lang=js"
export * from "./ProjectsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports